import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CustomerPhoneNumber } from '../../Models/Models/Customer/CustomerPhoneNumber';

declare var IS_RUNNING_IN_APP_POOL;

export class CustomerPhoneNumbersClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<CustomerPhoneNumber>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CustomerPhoneNumbers/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<CustomerPhoneNumber>, any>(url, data);
  }
  public put(customerId: number, phoneNumbers: Array<CustomerPhoneNumber>): Promise<Array<CustomerPhoneNumber>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CustomerPhoneNumbers/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, phoneNumbers: phoneNumbers }

    return AjaxWrapper.put<Array<CustomerPhoneNumber>, any>(url, data);
  }
}

